import { render, staticRenderFns } from "./LoyaltyPointScanListViewMobilePreview.vue?vue&type=template&id=6ed20234&scoped=true&"
import script from "./LoyaltyPointScanListViewMobilePreview.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointScanListViewMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointScanListViewMobilePreview.vue?vue&type=style&index=0&id=6ed20234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed20234",
  null
  
)

export default component.exports